import { render, staticRenderFns } from "./FileCabinet.vue?vue&type=template&id=72d96d65&"
import script from "./FileCabinet.vue?vue&type=script&lang=js&"
export * from "./FileCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d96d65')) {
      api.createRecord('72d96d65', component.options)
    } else {
      api.reload('72d96d65', component.options)
    }
    module.hot.accept("./FileCabinet.vue?vue&type=template&id=72d96d65&", function () {
      api.rerender('72d96d65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Reports/FileCabinet.vue"
export default component.exports